/* unplugin-vue-components disabled */import script from "./subscribe_list.vue?vue&type=script&setup=true&lang=js"
export * from "./subscribe_list.vue?vue&type=script&setup=true&lang=js"

import "./subscribe_list.vue?vue&type=style&index=0&id=380fd682&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-380fd682"]])

export default __exports__